/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getPaymentApprovalTable = params => {
  return axios.post(`${base}/getPaymentApprovalTable`, params)
}
export const getPaymentApprovalDetail = params => {
  return axios.get(`${base}/getPaymentApprovalDetail/${params.id}`, {params})
}
export const exportPaymentApprovalData = params => {
  return axios.get(`${base}/exportPaymentApprovalData/${params.id}`, {params})
}
export const createPaymentApprovalData = params => {
  return axios.post(`${base}/createPaymentApprovalData`, params)
}
export const updatePaymentApprovalData = params => {
  return axios.post(`${base}/updatePaymentApprovalData/${params.id}`, params)
}
export const deletePaymentApprovalData = params => {
  return axios.post(`${base}/deletePaymentApprovalData/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/payment-approval/payment-approval.api.js